import React from "react";

export default function OfficesIcon() {
  return (
    <svg
      version="1.1"
      width="26"
      height="26"
      x="0"
      y="0"
      viewBox="0 0 128 128"
    >
      <g>
        <path
          d="M78 19.99h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM90 19.99h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM102 19.99h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM114 19.99h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM78 27.991h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM90 27.991h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM102 27.991h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM114 27.991h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM78 35.992h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM90 35.992h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM102 35.992h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM114 35.992h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM78 43.993h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM90 43.993h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM102 43.993h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM114 43.993h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM78 51.993h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM90 51.993h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM102 51.993h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM114 51.993h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM78 59.994h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM90 59.994h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM102 59.994h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM114 59.994h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM102 67.995h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM114 67.995h4a2 2 0 0 0 0-4h-4a2 2 0 0 0 0 4ZM94 63.994h-4a1.987 1.987 0 0 0-1.528.724l7.134 2.458A1.992 1.992 0 0 0 94 63.994ZM118 71.995h-4a1.994 1.994 0 0 0-1.689.938l7.122 2.454A1.997 1.997 0 0 0 118 71.995Z"
          fill="currentColor"
          opacity="1"
          data-original="#000000"
        ></path>
        <path
          d="m126.213 9-56.01-6a2.179 2.179 0 0 0-1.474.445l-12 9.874A2 2 0 0 0 56 14.864v10.901l-25.798-2.763a2.162 2.162 0 0 0-1.473.444l-12 9.875A2 2 0 0 0 16 34.866V57.53l4-3.057V35.81l8-6.583V48.36l1.482-1.133A5.988 5.988 0 0 1 32 46.106v-18.89l24 2.573v23.74l4 1.378V15.808l8-6.583v48.439l4 1.378V7.215l52 5.572V76.96l3.954 1.363c.016.005.03.013.046.02V10.99A2 2 0 0 0 126.213 9Z"
          fill="currentColor"
          opacity="1"
          data-original="#000000"
        ></path>
        <path
          d="M126.651 82.105 33.777 50.102a1.998 1.998 0 0 0-1.866.302L.786 74.196A2 2 0 0 0 0 75.786V123a2 2 0 1 0 4 0V90.775l27-20.638V123a2 2 0 1 0 4 0V68.756l89 30.668v6.77l-15.864-5.467a2 2 0 0 0-1.302 3.783L124 110.425v5.77l-15.864-5.467a2 2 0 0 0-1.302 3.783L124 120.426V123a2 2 0 1 0 4 0V83.996a2 2 0 0 0-1.349-1.891ZM124 95.193l-90.223-31.09a1.978 1.978 0 0 0-.645-.095c-.045-.003-.087-.014-.132-.014a1.99 1.99 0 0 0-1.58.787L4 85.74v-8.967l29.488-22.54L124 85.423Z"
          fill="currentColor"
          opacity="1"
          data-original="#000000"
        ></path>
        <path
          d="M71 105.998a2 2 0 0 0 2-2v-11a2 2 0 0 0-1.368-1.899l-30-10A2 2 0 0 0 39 82.996v21.002a2 2 0 0 0 2 2ZM58 90.772l11 3.667v7.559H58Zm-15-5 11 3.666v12.56H43ZM23 101.998a2 2 0 1 0 4 0V81.996a2 2 0 0 0-3.212-1.59l-15.085 11.5a1.998 1.998 0 0 0-.787 1.591V123a2 2 0 1 0 4 0V94.487L23 86.036Z"
          fill="currentColor"
          opacity="1"
          data-original="#000000"
        ></path>
      </g>
    </svg>
  );
}
